import { Button, Card, CardActions, CardContent, CardHeader, Divider, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { ErrorMessage, MoneyDisplay } from "components";
import LoadingIndicator from "components/LoadingIndicator";
import MonoText from "components/MonoText";
import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Product } from "services";
import useErrorCatcher from "utils/useErrorCatcher";
import snakeToCamel from "utils/snakeToTitle";

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  content: {
  },
  actions: {
    flexDirection: "column",
    alignItems: "flex-start",
    "& > * + *": {
      marginLeft: 0
    }
  },
  notice: {
    marginTop: theme.spacing(1)
  },
  italics_light: {
    opacity: 0.7,
    fontStyle: "italic",
  },
  spinner: {
    marginTop: theme.spacing(3),
  },
  mono: {
    fontFamily: ["Roboto Mono", "monospace"],
  },
}));

let mounted = false;
const ProductPreview = props => {
  const { productId, className, ...rest } = props;
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [model, setModel] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const runAsyncBlock = useErrorCatcher(error => setErrorMessage(error && error.message));

  useEffect(() => {
    mounted = true;
    return () => mounted = false;
  }, [])

  useEffect(() => {
    runAsyncBlock(async () => {
      const { model } = await Product.detail(productId);
      if (mounted) setModel(model);
    }).finally(() => mounted && setLoading(false));

    return () => {
      if (mounted) setModel(null);
    };
    // eslint-disable-next-line
  }, [productId]);

  if (!productId) return null;

  const render_type = (model) => {
    if (!model) return "";
    switch(model.type) {
      case "credit_purchase": return "Topup Option";
      case "pass_purchase": return "Class Pass";
      default: return "";
    }
  }

  const render_route = (model) => {
    if (!model) return "";
    switch(model.type) {
      case "credit_purchase": return `/topup-options/${productId}/summary`;
      case "pass_purchase": return `/class-passes/${productId}/summary`;
      default: return `/products/${productId}/summary`;
    }
    
  }

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardHeader title={render_type(model)} />
      <Divider />
      <CardContent className={classes.content}>
        <ErrorMessage message={errorMessage} />
        <LoadingIndicator className={classes.spinner} variant="card" active={loading} />
        {model && (
          <Fragment>
            <Typography variant="h3">{model.name_en}</Typography>
            <Typography variant="body1"><MoneyDisplay amount={model.price} currency={model.price_currency} /></Typography>
            <Typography variant="body2" >{snakeToCamel(model.type)}</Typography>
            <Typography className={classes.mono} variant="body1" >
              <MonoText>SKU: {model.sku} | CODE: {model.code}</MonoText>
            </Typography>
          </Fragment>
        )}
      </CardContent>
      <CardActions className={classes.actions}>
        <Button component={RouterLink} size="small" to={render_route(model)}>
          View {render_type(model)} Details
        </Button>
      </CardActions>
    </Card>
  );
};

ProductPreview.propTypes = {
  className: PropTypes.string,
};

export default ProductPreview;
